export enum CargoCompanyOrderBillingsDownloadRequestStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPENED = "REOPENED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
}
export enum CargoCompanyOrderBillingsDownloadRequestOrder {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  TAXI_CORPORATION_ASC = "TAXI_ASC",
  TAXI_CORPORATION_DESC = "TAXI_DESC",
  EXTERNAL_ORDER_ID_ASC = "EXTERNAL_ID_ASC",
  EXTERNAL_ORDER_ID_DESC = "EXTERNAL_ID_DESC",
  DISPATCH_ASC = "DISPATCH_ASC",
  DISPATCH_DESC = "DISPATCH_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  HALTING_HOURS_ASC = "HALTING_HOURS_ASC",
  HALTING_HOURS_DESC = "HALTING_HOURS_DESC",
  HALTING_AMOUNT_ASC = "HALTING_AMOUNT_ASC",
  HALTING_AMOUNT_DESC = "HALTING_AMOUNT_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  DISCOUNT_ASC = "DISCOUNT_ASC",
  DISCOUNT_DESC = "DISCOUNT_DESC",
  DISCOUNT_AMOUNT_ASC = "DISCOUNT_AMOUNT_ASC",
  DISCOUNT_AMOUNT_DESC = "DISCOUNT_AMOUNT_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

export type CargoCompanyOrderBillingsDownloadQueryParams = {
  order?: CargoCompanyOrderBillingsDownloadRequestOrder;
  human_id?: string;
  passenger?: string;
  taxi?: string;
  date_since?: string;
  date_to?: string;
  external_id?: string;
  dispatch?: string;
  status?: CargoCompanyOrderBillingsDownloadRequestStatus;
  address?: string;
  start_address?: string;
  mid_address?: string;
  end_address?: string;
};

type CargoCompanyOrderBillingsDownloadRequest = {
  company_id: string;
  order?: CargoCompanyOrderBillingsDownloadRequestOrder;
  human_id?: string;
  passenger?: string;
  taxi?: string;
  date_since?: string;
  date_to?: string;
  external_id?: string;
  dispatch?: string;
  status?: CargoCompanyOrderBillingsDownloadRequestStatus;
  address?: string;
  start_address?: string;
  mid_address?: string;
  end_address?: string;
};

export default CargoCompanyOrderBillingsDownloadRequest;
